import React from "react";
import PropTypes from "prop-types";

export function TitleBlock(props) {
  return (
    <div className={props.className}>
      <div className={`${props.className}_progressBlock`}>{props.children}</div>
      <div className={`${props.className}_titleBlock`}>
        <p>
          {props.current}. {props.title}
        </p>
      </div>
    </div>
  );
}

TitleBlock.propTypes = {
  /**
   * ClassName to set for title block
   */
  className: PropTypes.string,
  /**
   * The title to display
   */
  title: PropTypes.string,
  /**
   * Current task number
   */
  current: PropTypes.number,
  /**
   * Progressbar component to be rendered inside TitleBlock
   */
  children: PropTypes.element,
};

TitleBlock.defaultProps = {
  className: "progressTracker_headblock",
  title: "",
  current: 1,
};
